import { observable, action, computed, ObservableMap } from 'mobx';
import {
    generateList,
} from './actionCreator';
import _ from '../translations';
import map from  'lodash/map';
import get from  'lodash/get';

class AddonProvider {
    @observable
    collection = new ObservableMap();
    @observable
    details = new ObservableMap();

    constructor() {
        this.baseUrl = '/api/generic';
    }

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action.bound
    async listProviders({ hash, params = {} } = {}) {
        return await generateList({
            hash,
            params,
            url: `${this.baseUrl}/providers/`,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem to obtaining providers'),
        })();
    }

    @computed
    get forSelect() {
        const page = this.collection.get('providerList');
        const items = map(page ? page.items : {}, item => ({
            text: get(item ,'name.original', 'Empty name'),
            value: item._id,
        }));
        return items;
    }
}

export default new AddonProvider();
